import { Head, useForm } from "@inertiajs/react";
import { LoaderCircle } from "lucide-react";
import type { FormEventHandler } from "react";

import InputError from "@/components/input-error";
import TextLink from "@/components/text-link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import AuthLayout from "@/layouts/auth-layout";
import { identityPasswordResetPath, signInPath } from "@/routes";

interface ForgotPasswordForm {
  email: string;
}

export default function ForgotPassword() {
  const { data, setData, post, processing, errors } = useForm<
    Required<ForgotPasswordForm>
  >({
    email: "",
  });

  const submit: FormEventHandler = (e) => {
    e.preventDefault();

    post(identityPasswordResetPath());
  };

  return (
    <AuthLayout
      title="Recupera tu contraseña"
      description="Ingresa tu correo electrónico para recibir instrucciones de recuperación"
    >
      <Head title="Recuperar contraseña" />

      <div className="space-y-6">
        <form onSubmit={submit}>
          <div className="grid gap-2">
            <Label htmlFor="email">Correo electrónico</Label>
            <Input
              id="email"
              type="email"
              name="email"
              autoComplete="off"
              value={data.email}
              autoFocus
              onChange={(e) => setData("email", e.target.value)}
              placeholder="tucorreo@ejemplo.com"
            />

            <InputError message={errors.email} />
          </div>

          <div className="my-6 flex items-center justify-start">
            <Button className="w-full" disabled={processing}>
              {processing && <LoaderCircle className="h-4 w-4 animate-spin" />}
              Enviar instrucciones por correo
            </Button>
          </div>
        </form>

        <div className="text-muted-foreground space-x-1 text-center text-sm">
          <span>O también puedes</span>
          <TextLink href={signInPath()}>volver a iniciar sesión</TextLink>
        </div>
      </div>
    </AuthLayout>
  );
}
